import React, {Component} from 'react';

import PropTypes from 'prop-types';
import FancyInput from "./FancyInput";
import _ from "lodash";
import browser from '../../../util/browser';
import SafariAuthCodeInput from "./SafariAuthCodeInput";

class AuthCodeInput extends Component {

  constructor(props){
    super(props);

    let numDigits = props.numDigits || 6

    this.state = {
      showShake: false,
      timer: null,
      digits : _.fill(Array(numDigits), ''),
      ie11hack : browser.isIE11()
    }

    this.digitFields = [];
  }

  componentDidMount() {
    if(this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount(){
    if(this.props.onRef) {
      this.props.onRef(undefined);
    }

    if(this.timer){
      clearTimeout(this.timer);
    }
  }

  triggerValidationErr(){
    if(this.safariAuthInputRef) {
      return this.safariAuthInputRef.triggerValidationErr();
    }

    var me = this;

    me.setState({
      showShake: true,
    }, () => {
      this.timer = setTimeout(() => {
        me.setState({
          showShake: false
        })
      }, 400) //same as the animation time
    })
  }

  focus(){
    if(this.safariAuthInputRef) {
      return this.safariAuthInputRef.focus();
    }

    this.digitFields[0].focus();
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   let { value } = this.props;
  //
  //   log.log('update?', value);
  //   if(value && value.length > 0 && value !== prevProps.value){
  //     log.log('componentDidUpdate', value);
  //     this.setState({
  //       digitOne: value && value[0] || '',
  //       digitTwo: value && value[1] || '',
  //       digitThree: value && value[2] || '',
  //       digitFour: value && value[3] || '',
  //       digitFive: value && value[4] || '',
  //       digitSix: value && value[5] || ''
  //     })
  //   }
  // }

  assembleCode(){
    if(this.safariAuthInputRef) {
      return this.safariAuthInputRef.getCodeValue();
    }

    return this.state.digits.join('');
  }

  onKeyPress(index, evt) {
    let keyValue = FancyInput.GetNumericKeyValue(evt);
    if(_.isNaN(keyValue) || keyValue < 0 || keyValue > 9){
      return;
    }
    else if(evt.key === 'Enter'){
      return;
    }

    index = +index;

    this.onDigitChange(index, ''+keyValue)
    setTimeout(() => {
      if (index < this.state.digits.length - 1) {
        let ref = this.getRefForIndex(index + 1);
        ref.focus();
      }
    })
  }

  onPaste(index, e) {
    let pastedText = e.clipboardData.getData('Text');
    let numDigits = this.state.digits.length;
    if(pastedText && pastedText.length === numDigits && !_.isNaN(+pastedText)){
      this.setState({
        digits : pastedText.split('')
      }, () => this.afterDigitChange())

      //Move the focus to the last input, like you typed it.
      let ref = this.getRefForIndex(numDigits - 1);
      ref.focus();
    }
    else{
      e.preventDefault();
    }
  }

  onDigitChange(index, val){
    index = +index;
    let updatedDigits = [...this.state.digits];
    updatedDigits[index] = val;
    this.setState({digits: updatedDigits}, () => this.afterDigitChange())
  }

  onEnter(index, evt){
    let { onEnter } = this.props;

    if(onEnter){
      onEnter();
    }
  }

  afterDigitChange(){
    if(this.props.onChange){
      this.props.onChange(this.assembleCode());
    }
  }

  onDelete(index, evt){

    //These digit values are BEFORE the delete.
    let digits = this.state.digits;
    let updatedDigits = [...digits];
    let nextRef = null;
    //index is 0 indexed.
    if(index === 0){
      if(digits[0] && digits[0].length > 0){
        updatedDigits[0] = '';
        this.setState({digits: updatedDigits}, () => this.afterDigitChange())
      }
    }
    else{
      if(!digits[index] || digits[index].length === 0){
        nextRef = this.digitFields[index - 1];
        updatedDigits[index - 1] = '';
        this.setState({digits: updatedDigits}, () => this.afterDigitChange())
      }
      else{
        updatedDigits[index] = '';
        this.setState({digits: updatedDigits}, () => this.afterDigitChange())
      }
    }

    if(nextRef){
      //This is a very weird edge case, but it looks like if I focus immediately, the delete hasn't been
      //handled yet, and it ends up deleting the character in the newly focused field.
      //I delay focus to fix. Seems crazy to me, but this fixes things.  Kind of scary.
      setTimeout(() => {
        nextRef.focus();
      }, 100)
    }
  }

  onFocus(index, evt) {
    let ref = this.getRefForIndex(index);
    if(ref){
      ref.selectAllText();
    }
  }

  getRefForIndex(index){
    return this.digitFields[index];
  }

  render() {
    let {
      inputDisabled,
      inputCls,
      label,
      useNonFloatingLabel
    } = this.props;

    if(browser.isSafari()) {
      return (
        <SafariAuthCodeInput inputDisabled={inputDisabled}
                             inputCls={inputCls}
                             label={label}
                             useNonFloatingLabel={useNonFloatingLabel}
                             numDigits={this.state.digits.length}
                             onChange={() => this.afterDigitChange()}
                             onEnter={this.onEnter.bind(this)}
                             onRef={(ref) => this.safariAuthInputRef = ref}/>
      )
    }

    let {
      digits,
      showShake,
      ie11hack
    } = this.state;

    let wrapStyle = {
      position: 'relative',
      overflow: 'initial',
    }

    if(showShake){
      wrapStyle.animation = 'shake 400ms ease-in-out';
    }

    let labelStyle = {
      pointerEvents: 'none',
      position: 'absolute',
      left: '0px',
      top: '-30px',
      fontSize: '12px',
      margin: '10px 10px 10px 25px',
      padding: '0 3px',
      backgroundColor: 'transparent',
      WebkitTransition: 'all .25s ease-in',
      transition: 'all .25s ease-in',
      color: '#fff'
    }
    if(useNonFloatingLabel){
      labelStyle = {};
    }

    let rowClass = 'd-flex';
    let colClass = `me-1 ${ie11hack ? 'flex-fill' : ''}`;
    let lastColClass = "";
    let appliedInputCls = `text-center ${ie11hack ? 'ie-11-hack' : ''} ${inputCls || ''}`

    return (
      <div className={'form-group auth-code-input'}>
        {label && label.length > 0 && <label style={labelStyle}>{label}</label> }
        <div style={wrapStyle} className={rowClass}>
          {digits.map((digitValue, index) => {
            let isLast = index === digits.length - 1;
            let appliedColClass = isLast ? lastColClass : colClass;

            return (
              <div className={appliedColClass} key={index}>
                <FancyInput inputDisabled={inputDisabled}
                            onRef={ref => (this.digitFields[index] = ref)}
                            fieldType={'tel'}
                            inputCls={appliedInputCls}
                            inputNumeric={true}
                            inputValue={digitValue}
                            maxInputLength={1}
                            onPaste={this.onPaste.bind(this, index)}
                            onFocus={this.onFocus.bind(this, index)}
                            onEnter={this.onEnter.bind(this, index)}
                            onDelete={this.onDelete.bind(this, index)}
                            onKeyPress={this.onKeyPress.bind(this, index)}/>
              </div>
            );
          })}
        </div>
      </div>
    )
  }
}

AuthCodeInput.propTypes = {
  onRef : PropTypes.func,
  onChange : PropTypes.func,
  onEnter: PropTypes.func,
  label: PropTypes.string,
  useNonFloatingLabel: PropTypes.bool,
  inputDisabled : PropTypes.bool.isRequired,
  inputCls : PropTypes.string,
  numDigits : PropTypes.number
}

export default AuthCodeInput;